import { IChannel } from '../data/api/models';

export const tagManagerEvent = (
    values: any,
    channel: IChannel,
) => {
    if (!channel.gtmId) {
        return;
    }

    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push(values);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/util/tagManagerEvent.ts